import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => localStorage.getItem("theme") || "light");

  const setTheme = (newTheme) => {
    const isStandalone = navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches;
    localStorage.setItem("theme", newTheme);
    if (isStandalone) {
      window.location.href = window.location.href;
      return;
    }
    setThemeState(newTheme);
  };

  useEffect(() => {
    const root = document.documentElement;
    const apply = (t) => {
      if (t === "dark") {
        root.classList.add("dark");
      } else if (t === "light") {
        root.classList.remove("dark");
      } else {
        // system
        const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
        root.classList.toggle("dark", prefersDark);
      }
    };

    apply(theme);
    localStorage.setItem("theme", theme);

    // Opdater iOS status bar og theme-color meta-tag dynamisk
    const isDark = theme === "dark" || (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
    const themeColor = isDark ? "#0a0a0a" : "#ffffff";
    const statusBar = isDark ? "black" : "default";
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", themeColor);
    document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]')?.setAttribute("content", statusBar);

    if (theme === "system") {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      const handler = (e) => {
        root.classList.toggle("dark", e.matches);
        const tc = e.matches ? "#0a0a0a" : "#ffffff";
        const sb = e.matches ? "black" : "default";
        document.querySelector('meta[name="theme-color"]')?.setAttribute("content", tc);
        document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]')?.setAttribute("content", sb);
      };
      mq.addEventListener("change", handler);
      return () => mq.removeEventListener("change", handler);
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
